<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="予約内容"
        ok-only
        ok-title="閉じる"
        ok-variant="yokumiru-gray"
        @hidden="close">
        <div v-if="isLoaded">
            <div class="card">
                <div class="card-header">
                    <div class="font-weight-bold">基本情報</div>
                </div>

                <div class="card-body">
                    <dl>
                        <dt>予約番号</dt>
                        <dd>
                            <span>#{{ consultation.id }}</span>
                            <span v-if="Number( consultation.flg_reserved_by_doctor ) === 1"
                                  class="small">
                                （医師による予約）
                            </span>
                        </dd>
                    </dl>
                    <dl>
                        <dt>予約日時</dt>
                        <dd class="u-palt">
                            <div>
                                <span>{{ helper.dateForHuman(consultation.start_time, timezone, {exceptYear: true}) }}</span>
                                <span :class="helper.dayForHumanCSS(consultation.start_time ,timezone)">
                                    {{ helper.dayForHuman(consultation.start_time, timezone, {bracket: true}) }}
                                </span>
                                <span>{{ helper.timeForHuman(consultation, timezone) }}</span>
                                <span v-if="consultation.doctor_menu !== null">
                                    {{ `（${consultation.doctor_menu.consultation_minutes}分）` }}
                                </span>
                            </div>
                            <timezone-box-jst
                                v-if="timezone !== 'Asia/Tokyo'"
                                :consultation="consultation"
                                :timezone="timezone"
                                except-year>
                            </timezone-box-jst>
                        </dd>
                    </dl>
                    <dl v-if="isPayPrice">
                        <dt>お支払い方法</dt>
                        <dd>{{ consultation.payment_method.name }}</dd>
                    </dl>
                    <dl v-if="isPayPrice">
                        <dt>{{ $locale.type === 'consul' ? '金額（税込）' : '金額' }}</dt>
                        <template v-if="$locale.type === 'consul'">
                            <span>{{ `${estimate.total.toLocaleString()}円` }}</span>
                        </template>
                        <template v-else>
                            <span>{{ `${ $locale.consultation_guest }終了後に確定` }}</span>
                        </template>
                    </dl>
                </div>
            </div>

            <div class="card mt-3">
                <div class="card-header">
                    <div class="font-weight-bold">メニュー詳細</div>
                </div>
                <div class="card-body">
                    <doctor-menu-info
                        :menu="consultation.doctor_menu"
                        :user="user"
                        :consultation="consultation"
                        doctor-introduction-type="history">
                    </doctor-menu-info>
                </div>
            </div>

            <div class="mt-3">
                <div class="mb-3">
                    <user-interview-answers
                        disabled-button
                        :consultation-id="consultation.id"
                        :flg-reserved-by-doctor="consultation.flg_reserved_by_doctor">
                    </user-interview-answers>
                </div>
            </div>
        </div>
        <div
            v-else
            class="d-flex justify-content-center align-items-center">
            <b-spinner variant="yokumiru-user"></b-spinner>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'

    export default {
        props: {
            user: {
                type: Object,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                consultation: null,
                doctor: null,
                modalShow: false,
                estimate: null,
            }
        },

        computed: {
            timezone: function () {
                return this.user.timezone
            },

            isLoaded: function () {
                return this.consultation !== null
                    && (this.estimate !== null || this.$locale.type !== 'consul')
            },

            /**
             * 相談料の決済が必要かどうか
             * @return {boolean}
             */
            isPayPrice: function () {
                if (this.$locale.type !== 'consul') {
                    return false
                }
                if (!this.consultation || this.isFreeMenu || this.isHealthPackage) {
                    return false
                }
                return this.user.plan.is_pay_consultation_price
            },

            /**
             * 無料メニューかどうか
             * @return {boolean}
             */
            isFreeMenu: function () {
                return this.consultation
                    && this.consultation.doctor_menu
                    && this.consultation.doctor_menu.consultation_price < 1
            },

            /**
             * 健康管理パッケージのメニューかどうか
             * @return {boolean}
             */
            isHealthPackage: function () {
                return this.consultation
                    && this.consultation.doctor_menu
                    && this.consultation.doctor_menu.is_health_package
            },
        },

        created: function() {
            bus.$on('open-modal-consultation-detail', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-consultation-detail')
        },

        methods: {
            open: function (consultation) {
                this.modalShow = true
                this.consultation = consultation
                this.doctor = consultation.doctor
                this.fetchEstimate()
            },

            close: function () {
                this.modalShow = false
                this.consultation = null
                this.doctor = null
            },

            /**
             * 金額（税込）
             *
             * @return {number|void}
             */
            fetchEstimate: function () {
                if (this.$locale.type !== 'consul') {
                    return
                }

                let endpoint = `${constants.user.consultations.endpoint.base}/estimate`
                endpoint += `?medical_course_id=${this.consultation.medical_course_id}`

                if (this.consultation.doctor_menu_id) {
                    endpoint += `&doctor_menu_id=${this.consultation.doctor_menu_id}`
                }
                if (this.consultation.user_coupon) {
                    endpoint += `&user_coupon_id=${this.consultation.user_coupon.id}`
                }

                axios.get(endpoint).then(({data}) => {
                    this.estimate = data.data
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
.profileDoctorImage {
    overflow: hidden;
    width: 120px;
    height: 120px;
    border-radius: 50%;

    img {
        object-fit: cover;
        width: 100%;
        height: 100%;
    }
}

.profileDoctorName {
    color: #2A2E31;
    font-weight: bold;

    span {
        font-size: 21px;

        &:nth-child(2) {
            font-size: 14px;
        }
    }
}

.profileDoctorDetail {
    margin: 5px 0 0 32px;
}

.profileDoctorMedicalCourse {
    color: #7D868D;
    font-size: 14px;
    font-feature-settings: 'palt';
    line-height: 1;

    &::after {
        content: '、';
    }

    &:last-child {
        &::after {
            display: none;
        }
    }
}

.profileDoctorLabel {
    margin-right: 5px;
    padding: 2px 12px;
    color: #B49834;
    font-size: 13px;
    border: 1px solid #EDECDC;
    background-color: #F7F8F2;
    border-radius: 6px;

    &:last-child {
        margin-right: 0;
    }
}

.profileDoctorHistory {
    color: #757C83;
}

.profileDoctorHistoryTitle {
    font-weight: bold;
}

.profileDoctorLicense {
    color: #757C83;
}

.profileDoctorLicenseTitle {
    font-weight: bold;
}
</style>
